export const environment = {
	production: true,
	baseUrl: 'https://www.newxlife.xlsmart.co.id/en',
	DOMAIN_URL: 'https://api.newxlife.xl.co.id/prod',
	BO_URL: 'https://admin.newxlife.xlsmart.co.id',
	EMR_ADMIN_URL: 'https://mradmin.newxlife.xlsmart.co.id',
	EWP_ADMIN_URL: 'https://ewp.newxlife.xlsmart.co.id',
	EN_URL: 'https://www.newxlife.xlsmart.co.id/en',
	ID_URL: 'https://www.newxlife.xlsmart.co.id/id',
	api: {
		apiV1: 'https://api.newxlife.xl.co.id/prod',
	},
	foURL: 'https://www.newxlife.xlsmart.co.id/en/',
	XL_SATU_URL: 'https://satu.xl.co.id',
};
